import { Flex } from 'theme-ui'
import TextWithOverFlowAndTippyPopup from 'components/TextWithOverFlowAndTippyPopup'
import React, { ReactElement } from 'react'
import { useGetProxiesNoAuthQuery } from 'store/api/proxies'
import useBreakpointIndex from 'ui/Theme/useBreakpointIndex'
import { CurrentLocationIcon } from 'components/Dashboard/Profiles/DefaultLocation/CurrentLocationIcon'
import { Svg } from 'ui'
import GlobeIcon from 'images/small-globe-icon.svg'
import { getFormattedCityCountryIsp, getFormattedIsp } from 'utils/getFormattedCityCountryIsp'
import useGetColorMode from 'utils/useGetColorMode'

export default function IpDescription({
  country,
  city,
  isp,
}: {
  country?: string
  city?: string
  isp?: string
}): ReactElement {
  const { data: proxiesData } = useGetProxiesNoAuthQuery('')
  const locations = proxiesData?.proxies
  const isMobile = useBreakpointIndex() === 0
  const { isLightMode } = useGetColorMode()

  return (
    <Flex
      sx={{
        textAlign: 'right',
        justifyContent: ['flex-start', 'flex-end'],
        maxWidth: 'fit-content',
        alignSelf: 'flex-end',
        color: 'lightSteelBlue',
      }}
      className="fill-available"
    >
      {/* check that there is a country code associated with this IP and a proxy location associated with that country code */}
      {country && locations?.find(location => location.country === country) ? (
        <Flex sx={{ mr: '0.9rem', flexShrink: 0, alignItems: 'center' }}>
          <CurrentLocationIcon
            currentLocation={locations?.find(location => location.country === country)}
            isConnected={false}
            isSmallIcon
          />
        </Flex>
      ) : (
        <Flex sx={{ mr: '0.8rem', alignItems: 'center' }}>
          <Svg
            svg={GlobeIcon}
            descriptiveText="Globe icon"
            fill="title60"
            sx={{ height: '1.6rem', width: '1.7rem', flexShrink: 0 }}
          />
        </Flex>
      )}
      <TextWithOverFlowAndTippyPopup
        theme={isLightMode ? 'light-org-tooltip' : 'org-tooltip'}
        testId="my-ips-city-country-isp"
        variant={['size12Weight400Line138', 'size15Weight400Line138']}
        content={
          isMobile ? getFormattedIsp(isp) : getFormattedCityCountryIsp({ city, country, isp })
        }
        ariaLabel={
          isMobile ? getFormattedIsp(isp) : getFormattedCityCountryIsp({ city, country, isp })
        }
      />
    </Flex>
  )
}
